import IconButton from '@mui/material/IconButton';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Tooltip, Stack, Paper, useMediaQuery, useTheme } from '@mui/material';

const EventTile = ({ event, onUpload, onView, onDelete, userRole }) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className="eventlist-tile">
      {/* <div className="titles">
        <div>
          <p>Event Name:</p>
          <div>{event.eventName}</div>
        </div>
        <div>
          <p>Event Date:</p>
          <div>{event.eventDate}</div>
        </div>

        <div>
          <p>Reps:</p>
          <div>
            {event.addedReps.map((rep, index) => (
              <span
                key={index}
                style={{
                  margin: '2px',
                  display: 'inline-block',
                  fontWeight: 'bold',
                }}
              >
                {rep.split(' ')[0]}
                {index < event.addedReps.length - 1 && ', '}
              </span>
            ))}
          </div>
        </div>
      </div> */}
      <div className="titles">
        <p className="label">Name:</p>

        <p className="label">Date:</p>

        <p className="label">Reps:</p>
      </div>
      <div className="titles-value">
        <div className="value value-name">{event.eventName}</div>
        <div className="value">{event.eventDate}</div>
        <div className="reps-value">
          {event.addedReps.map((rep, index) => (
            <span key={index} className="rep-tag">
              {rep.split(' ')[0]}
              {index < event.addedReps.length - 1 && ', '}
            </span>
          ))}
        </div>
      </div>

      {/* <div className='button-row'>
                
                <IconButton onClick={() => onUpload(event.eventName, event.eventDate)} sx={{ ml: 2 }} color="primary">
                    <UploadFileIcon />
                </IconButton>

                <IconButton onClick={() => onView(event.eventName, event.eventDate)} sx={{ ml: 2 }} color="secondary">
                    <VisibilityIcon />
                </IconButton>
                {userDetail?.role === 'admin' ? <IconButton onClick={() => onDelete(event._id, event.eventName)} sx={{ ml: 2 }} color="error">
                    <DeleteIcon />
                </IconButton> : <></>}
            </div> */}
      <div className="button-row">
        <Paper
          elevation={0}
          sx={{
            // minWidth: isMediumScreen ? 'auto' : 250,
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            borderRadius: 3,
          }}
        >
          <Stack direction={isSmallScreen ? 'column' : 'row'} spacing={1} alignItems="center">
            <Tooltip title="Upload Files">
              <IconButton
                onClick={() => onUpload(event._id,event.eventName, event.eventDate)}
                color="primary"
                style={{ padding: '0 8px' }}
              >
                <UploadFileIcon fontSize={isMediumScreen ? 'medium' : 'large'} />
              </IconButton>
            </Tooltip>

            <Tooltip title="View CIS Details">
              <IconButton
                onClick={() => onView(event.eventName, event.eventDate)}
                color="secondary"
                style={{ padding: '0 8px' }}
              >
                <VisibilityIcon fontSize={isMediumScreen ? 'medium' : 'large'} />
              </IconButton>
            </Tooltip>

            {userRole === 'admin' && (
              <Tooltip title="Delete Whole Event">
                <IconButton
                  onClick={() => onDelete(event._id, event.eventName)}
                  color="error"
                  style={{ padding: '0 8px' }}
                >
                  <DeleteIcon fontSize={isMediumScreen ? 'medium' : 'large'} />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Paper>
      </div>
    </div>
  );
};

export default EventTile;
